import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent } from '../components/ui/card';
import { ScrollText, Edit2, Save, X, Plus, Trash2, ArrowUp, ArrowDown, FileDown, Calendar, Hash } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Default template from PDF
const DEFAULT_TERMS_CONTENT = [
  { id: '1', type: 'heading', content: 'Termini e Condizioni d\'uso' },
  { id: '2', type: 'note', content: 'Ultimo aggiornamento: 04 febbraio 2026 alle ore 10:00' },
  { id: '3', type: 'heading', content: 'Definizioni' },
  { id: '4', type: 'paragraph', content: 'Ai fini dei presenti Termini e Condizioni d\'uso, si intende per:' },
  { id: '5', type: 'list', content: 'Piattaforma o Sistema e-CAA: L\'applicazione web per la valutazione della maturità dei processi di sicurezza e gestione dei fornitori dei Centri di Assistenza Agricola.\nTitolare: Federlombarda Agricoltori, proprietaria e gestore della Piattaforma.\nUtente: Qualsiasi persona fisica autorizzata ad accedere e utilizzare la Piattaforma con le credenziali assegnate.\nOrganizzazione: L\'ente o struttura CAA a cui l\'Utente appartiene e per conto della quale opera nella Piattaforma.\nInformazioni Riservate: Tutti i dati, documenti, informazioni, risultati e contenuti accessibili attraverso la Piattaforma.' },
  { id: '6', type: 'heading', content: 'Descrizione del Servizio' },
  { id: '7', type: 'paragraph', content: 'La Piattaforma e-CAA è un sistema informatico che consente:' },
  { id: '8', type: 'list', content: 'La compilazione di questionari strutturati per la valutazione della maturità dei processi\nIl calcolo automatico dei punteggi e dei rating di valutazione\nLa gestione dei dati anagrafici delle organizzazioni CAA\nLa consultazione dello storico delle valutazioni effettuate\nL\'esportazione dei risultati in formato PDF' },
  { id: '9', type: 'paragraph', content: 'L\'accesso alla Piattaforma è riservato esclusivamente agli Utenti autorizzati e si configura come servizio professionale destinato alle organizzazioni aderenti alla rete Federlombarda.' },
  { id: '10', type: 'heading', content: 'Accesso e Credenziali' },
  { id: '11', type: 'paragraph', content: 'L\'accesso alla Piattaforma richiede credenziali personali (email e password) assegnate dal Titolare o dall\'amministratore di sistema.' },
  { id: '12', type: 'paragraph', content: 'Responsabilità sulle credenziali:' },
  { id: '13', type: 'list', content: 'Le credenziali sono strettamente personali e non cedibili\nL\'Utente è l\'unico responsabile della custodia delle proprie credenziali\nQualsiasi attività svolta con le credenziali dell\'Utente è imputata all\'Utente stesso\nIn caso di smarrimento o sospetta compromissione, l\'Utente deve notificare immediatamente il Titolare' },
  { id: '14', type: 'heading', content: 'Obblighi dell\'Utente' },
  { id: '15', type: 'paragraph', content: 'L\'Utente si impegna a:' },
  { id: '16', type: 'list', content: 'Utilizzare la Piattaforma esclusivamente per le finalità previste e nell\'interesse dell\'Organizzazione di appartenenza\nFornire informazioni accurate e veritiere nella compilazione dei questionari\nNon tentare di accedere a dati o funzionalità non autorizzate\nNon utilizzare strumenti automatizzati per l\'accesso o l\'estrazione massiva di dati\nNon compiere azioni che possano compromettere la sicurezza o il funzionamento della Piattaforma\nRispettare tutte le disposizioni di legge applicabili' },
  { id: '17', type: 'paragraph', content: 'La violazione degli obblighi sopra indicati può comportare la sospensione o la revoca immediata dell\'accesso, oltre ad eventuali conseguenze legali.' },
  { id: '18', type: 'heading', content: 'Accordo di Riservatezza (NDA)' },
  { id: '19', type: 'paragraph', content: 'Con l\'accettazione dei presenti Termini, l\'Utente sottoscrive un impegno vincolante di riservatezza su tutte le Informazioni Riservate accessibili attraverso la Piattaforma.' },
  { id: '20', type: 'paragraph', content: 'Obblighi di riservatezza - L\'Utente si impegna irrevocabilmente a:' },
  { id: '21', type: 'list', content: 'Mantenere la massima riservatezza su tutte le Informazioni Riservate a cui ha accesso\nNon divulgare, comunicare, trasmettere o rendere accessibili a terzi non autorizzati alcuna Informazione Riservata\nNon effettuare copie, screenshot, registrazioni audio/video, fotografie o qualsiasi altra riproduzione delle informazioni visualizzate\nNon utilizzare le Informazioni Riservate per scopi diversi da quelli strettamente connessi alle proprie mansioni lavorative\nProteggere le Informazioni Riservate con la stessa diligenza usata per proteggere le proprie informazioni riservate' },
  { id: '22', type: 'paragraph', content: 'Durata dell\'obbligo: L\'obbligo di riservatezza permane senza limiti temporali, anche dopo la cessazione dell\'accesso alla Piattaforma, la conclusione del rapporto lavorativo con l\'Organizzazione, o qualsiasi altro evento che determini la perdita dello status di Utente autorizzato.' },
  { id: '23', type: 'paragraph', content: 'Conseguenze della violazione: La violazione degli obblighi di riservatezza comporta revoca immediata dell\'accesso alla Piattaforma, segnalazione all\'Organizzazione di appartenenza, azioni legali per il risarcimento di tutti i danni subiti dal Titolare e/o da terzi, eventuali conseguenze penali previste dalla legge.' },
  { id: '24', type: 'heading', content: 'Proprietà Intellettuale' },
  { id: '25', type: 'paragraph', content: 'Tutti i diritti di proprietà intellettuale sulla Piattaforma, inclusi codice sorgente, architettura e design del software, interfaccia grafica, loghi e marchi, struttura dei questionari e metodologia di valutazione, documentazione, guide e materiali formativi, sono e rimangono di esclusiva proprietà del Titolare e/o dei rispettivi licenzianti.' },
  { id: '26', type: 'paragraph', content: 'L\'accesso alla Piattaforma non conferisce all\'Utente alcun diritto di proprietà intellettuale, ma esclusivamente una licenza d\'uso limitata, non esclusiva e non trasferibile, per le sole finalità previste dal servizio.' },
  { id: '27', type: 'heading', content: 'Limitazione di Responsabilità' },
  { id: '28', type: 'paragraph', content: 'Il Titolare fornisce la Piattaforma "così com\'è" e non garantisce la disponibilità continua e ininterrotta del servizio, l\'assenza di errori o malfunzionamenti, l\'idoneità della Piattaforma a scopi specifici dell\'Utente.' },
  { id: '29', type: 'paragraph', content: 'Il Titolare non sarà responsabile per danni diretti, indiretti, incidentali, consequenziali o punitivi, perdita di dati, profitti o opportunità commerciali, interruzioni del servizio dovute a cause di forza maggiore o a terzi, uso improprio della Piattaforma da parte dell\'Utente.' },
  { id: '30', type: 'heading', content: 'Sospensione e Revoca dell\'Accesso' },
  { id: '31', type: 'paragraph', content: 'Il Titolare si riserva il diritto di sospendere o revocare l\'accesso dell\'Utente alla Piattaforma, con o senza preavviso, nei seguenti casi:' },
  { id: '32', type: 'list', content: 'Violazione dei presenti Termini e Condizioni d\'uso\nViolazione degli obblighi di riservatezza\nRichiesta da parte dell\'Organizzazione di appartenenza\nCessazione del rapporto tra l\'Utente e l\'Organizzazione\nAttività sospette o potenzialmente dannose per la sicurezza del sistema\nMancato utilizzo prolungato della Piattaforma\nQualsiasi altra ragione legittima a insindacabile giudizio del Titolare' },
  { id: '33', type: 'heading', content: 'Modifiche ai Termini' },
  { id: '34', type: 'paragraph', content: 'Il Titolare si riserva il diritto di modificare i presenti Termini e Condizioni d\'uso in qualsiasi momento. Eventuali modifiche saranno comunicate agli Utenti attraverso notifica via email, avviso all\'interno della Piattaforma, richiesta di nuova accettazione al successivo accesso.' },
  { id: '35', type: 'paragraph', content: 'L\'utilizzo continuato della Piattaforma dopo la notifica delle modifiche costituisce accettazione dei nuovi termini.' },
  { id: '36', type: 'heading', content: 'Legge Applicabile e Foro Competente' },
  { id: '37', type: 'paragraph', content: 'I presenti Termini e Condizioni d\'uso sono regolati dalla legge italiana. Per qualsiasi controversia derivante dall\'interpretazione, esecuzione o risoluzione dei presenti Termini, sarà competente in via esclusiva il Foro di Milano.' }
];

const TermsConditions = () => {
  const { token, user } = useAuth();
  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [editedContent, setEditedContent] = useState([]);
  const [saving, setSaving] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [isMinorChange, setIsMinorChange] = useState(false);
  const [currentVersion, setCurrentVersion] = useState(1);
  const [manualVersion, setManualVersion] = useState('');
  const [lastUpdated, setLastUpdated] = useState(null);
  
  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin';

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await axios.get(`${API}/legal/terms-conditions`);
      if (response.data && response.data.content && response.data.content.length > 0) {
        setContent(response.data.content);
        setCurrentVersion(response.data.version || 1);
        setLastUpdated(response.data.updated_at);
      } else {
        setContent(DEFAULT_TERMS_CONTENT);
      }
    } catch (error) {
      console.error('Error fetching terms:', error);
      setContent(DEFAULT_TERMS_CONTENT);
    } finally {
      setLoading(false);
    }
  };

  const startEditing = () => {
    setEditedContent(JSON.parse(JSON.stringify(content)));
    setIsEditing(true);
    setIsMinorChange(false);
    setManualVersion('');
  };

  const cancelEditing = () => {
    setEditedContent([]);
    setIsEditing(false);
    setIsMinorChange(false);
    setManualVersion('');
  };

  const saveContent = async () => {
    setSaving(true);
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const payload = { 
        content: editedContent,
        is_minor_change: isMinorChange
      };
      
      // Add manual version if specified
      if (manualVersion && !isNaN(parseInt(manualVersion))) {
        payload.version = parseInt(manualVersion);
      }
      
      const response = await axios.put(`${API}/legal/terms-conditions`, payload, { headers });
      setContent(editedContent);
      setCurrentVersion(response.data.version || currentVersion);
      setIsEditing(false);
      setIsMinorChange(false);
      setManualVersion('');
      toast.success(response.data.message || 'Termini e Condizioni aggiornati con successo');
    } catch (error) {
      console.error('Error saving terms:', error);
      toast.error('Errore nel salvataggio');
    } finally {
      setSaving(false);
    }
  };

  const updateBlock = (id, newContent) => {
    setEditedContent(prev => prev.map(block => 
      block.id === id ? { ...block, content: newContent } : block
    ));
  };

  const changeBlockType = (id, newType) => {
    setEditedContent(prev => prev.map(block => 
      block.id === id ? { ...block, type: newType } : block
    ));
  };

  const addBlock = (afterId, type = 'paragraph') => {
    const newBlock = {
      id: Date.now().toString(),
      type,
      content: type === 'heading' ? 'Nuovo Titolo' : type === 'list' ? 'Elemento 1\nElemento 2' : 'Nuovo paragrafo...'
    };
    
    const index = editedContent.findIndex(b => b.id === afterId);
    const newContent = [...editedContent];
    newContent.splice(index + 1, 0, newBlock);
    setEditedContent(newContent);
  };

  const deleteBlock = (id) => {
    if (editedContent.length <= 1) {
      toast.error('Deve esserci almeno un blocco');
      return;
    }
    setEditedContent(prev => prev.filter(block => block.id !== id));
  };

  const moveBlock = (id, direction) => {
    const index = editedContent.findIndex(b => b.id === id);
    if ((direction === 'up' && index === 0) || (direction === 'down' && index === editedContent.length - 1)) {
      return;
    }
    
    const newContent = [...editedContent];
    const newIndex = direction === 'up' ? index - 1 : index + 1;
    [newContent[index], newContent[newIndex]] = [newContent[newIndex], newContent[index]];
    setEditedContent(newContent);
  };

  const exportToPdf = async () => {
    setExporting(true);
    try {
      const response = await axios.get(`${API}/legal/terms-conditions/export-pdf`, {
        responseType: 'blob'
      });
      
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Termini_e_Condizioni_e-CAA-FDL_${new Date().toISOString().split('T')[0]}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      toast.success('PDF esportato con successo');
    } catch (error) {
      console.error('Error exporting PDF:', error);
      toast.error('Errore nell\'esportazione del PDF');
    } finally {
      setExporting(false);
    }
  };

  const renderBlock = (block) => {
    switch (block.type) {
      case 'heading':
        return <h2 className="text-xl font-bold text-slate-800 mt-8 mb-3 first:mt-0">{block.content}</h2>;
      case 'paragraph':
        return <p className="text-slate-600 leading-relaxed mb-4 whitespace-pre-line">{block.content}</p>;
      case 'list':
        return (
          <ul className="list-disc list-outside ml-5 text-slate-600 mb-4 space-y-2">
            {block.content.split('\n').map((item, i) => (
              <li key={i} className="leading-relaxed">{item}</li>
            ))}
          </ul>
        );
      case 'note':
        return (
          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 my-4">
            <p className="text-blue-800 text-sm">{block.content}</p>
          </div>
        );
      default:
        return <p className="text-slate-600">{block.content}</p>;
    }
  };

  const renderEditableBlock = (block) => {
    return (
      <div key={block.id} className="group relative border border-slate-200 rounded-lg p-4 mb-3 bg-white hover:border-[#3BA99C] transition-colors">
        <div className="absolute -top-3 left-3 flex items-center gap-1 bg-white px-2 z-10">
          <Select value={block.type} onValueChange={(value) => changeBlockType(block.id, value)}>
            <SelectTrigger className="h-7 text-xs border-slate-200 bg-white w-28">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="heading">Titolo</SelectItem>
              <SelectItem value="paragraph">Paragrafo</SelectItem>
              <SelectItem value="list">Lista</SelectItem>
              <SelectItem value="note">Nota</SelectItem>
            </SelectContent>
          </Select>
        </div>
        
        <div className="absolute -top-3 right-3 flex items-center gap-1 bg-white px-1 opacity-0 group-hover:opacity-100 transition-opacity">
          <button onClick={() => moveBlock(block.id, 'up')} className="p-1 hover:bg-slate-100 rounded" title="Sposta su">
            <ArrowUp className="w-3.5 h-3.5 text-slate-500" />
          </button>
          <button onClick={() => moveBlock(block.id, 'down')} className="p-1 hover:bg-slate-100 rounded" title="Sposta giù">
            <ArrowDown className="w-3.5 h-3.5 text-slate-500" />
          </button>
          <button onClick={() => deleteBlock(block.id)} className="p-1 hover:bg-red-100 rounded" title="Elimina blocco">
            <Trash2 className="w-3.5 h-3.5 text-red-500" />
          </button>
        </div>

        <textarea
          value={block.content}
          onChange={(e) => updateBlock(block.id, e.target.value)}
          className={`w-full border-0 focus:outline-none focus:ring-0 resize-y ${
            block.type === 'heading' ? 'text-lg font-bold min-h-[40px]' : 'text-sm min-h-[80px]'
          }`}
          placeholder={block.type === 'heading' ? 'Titolo sezione...' : block.type === 'list' ? 'Un elemento per riga...' : 'Contenuto...'}
        />

        <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity">
          <button
            onClick={() => addBlock(block.id)}
            className="flex items-center gap-1 px-2 py-1 bg-[#3BA99C] text-white text-xs rounded hover:bg-[#2D8A7F]"
          >
            <Plus className="w-3 h-3" />
            Aggiungi
          </button>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#3BA99C]"></div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-slate-900 flex items-center gap-3">
            <ScrollText className="w-8 h-8 text-[#21358E]" />
            Termini e Condizioni
          </h1>
          <div className="flex items-center gap-3 mt-1">
            <p className="text-slate-500">Condizioni di utilizzo della piattaforma</p>
            <span className="px-2 py-0.5 bg-[#21358E]/10 text-[#21358E] text-xs font-medium rounded">
              v{currentVersion}
            </span>
            {lastUpdated && (
              <span className="text-xs text-slate-400 flex items-center gap-1">
                <Calendar className="w-3 h-3" />
                {new Date(lastUpdated).toLocaleDateString('it-IT')}
              </span>
            )}
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          {/* Export PDF Button - sempre visibile */}
          {!isEditing && (
            <button
              onClick={exportToPdf}
              disabled={exporting}
              className="flex items-center gap-2 px-4 py-2 bg-[#21358E] hover:bg-[#1a2a6c] text-white rounded-lg transition-colors disabled:opacity-50"
              data-testid="export-terms-pdf-btn"
              title="Esporta in PDF"
            >
              <FileDown className="w-4 h-4" />
              {exporting ? 'Esportazione...' : 'Esporta PDF'}
            </button>
          )}
          
          {isAdmin && !isEditing && (
            <button
              onClick={startEditing}
              className="flex items-center gap-2 px-4 py-2 bg-[#3BA99C] hover:bg-[#2D8A7F] text-white rounded-lg transition-colors"
              data-testid="edit-terms-btn"
            >
              <Edit2 className="w-4 h-4" />
              Modifica
            </button>
          )}
          
          {isAdmin && isEditing && (
            <div className="flex items-center gap-4 flex-wrap">
              {/* Campo versione manuale */}
              <div className="flex items-center gap-2 px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg">
                <Hash className="w-4 h-4 text-slate-500" />
                <input
                  type="number"
                  min="1"
                  value={manualVersion}
                  onChange={(e) => setManualVersion(e.target.value)}
                  placeholder={`v${currentVersion}`}
                  className="w-16 text-sm border-0 bg-transparent focus:outline-none focus:ring-0"
                  title="Versione (lascia vuoto per auto-incremento)"
                />
                <span className="text-xs text-slate-500">versione</span>
              </div>
              
              {/* Checkbox modifica minore */}
              <label className="flex items-center gap-2 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg cursor-pointer hover:bg-amber-100 transition-colors">
                <input
                  type="checkbox"
                  checked={isMinorChange}
                  onChange={(e) => {
                    setIsMinorChange(e.target.checked);
                    if (e.target.checked) setManualVersion('');
                  }}
                  disabled={manualVersion !== ''}
                  className="w-4 h-4 text-amber-600 rounded border-amber-300 focus:ring-amber-500"
                />
                <span className="text-sm text-amber-800">
                  Modifica minore <span className="text-xs text-amber-600">(stessa versione)</span>
                </span>
              </label>
              
              <button
                onClick={cancelEditing}
                className="flex items-center gap-2 px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg transition-colors"
              >
                <X className="w-4 h-4" />
                Annulla
              </button>
              <button
                onClick={saveContent}
                disabled={saving}
                className="flex items-center gap-2 px-4 py-2 bg-[#3BA99C] hover:bg-[#2D8A7F] text-white rounded-lg transition-colors disabled:opacity-50"
                data-testid="save-terms-btn"
              >
                <Save className="w-4 h-4" />
                {saving ? 'Salvataggio...' : 'Salva'}
              </button>
            </div>
          )}
        </div>
      </div>

      <Card>
        <CardContent className="pt-6">
          {isEditing ? (
            <div className="space-y-4">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4">
                <p className="text-sm text-blue-700">
                  <strong>Modalità modifica:</strong> Clicca sui blocchi per modificarli. Usa i controlli per cambiare tipo, riordinare o eliminare.
                </p>
              </div>
              {editedContent.map(block => renderEditableBlock(block))}
            </div>
          ) : (
            <div className="prose prose-slate max-w-none">
              {content.map(block => (
                <div key={block.id}>{renderBlock(block)}</div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default TermsConditions;
